import Component, { mixins } from 'vue-class-component';
import { I18nMixin } from '../helpers/i18n';
import { uid } from '../helpers/utils';

@Component
export default class Base extends mixins(I18nMixin) {
    public uniqId: string;

    public beforeCreate(): void {
        this.uniqId = uid();
    }
}



// WEBPACK FOOTER //
// ./src/components/Base.ts